import { EmojiPickerV4 } from "@circle-react-uikit/EmojiPickerV4";
import { Icon } from "@circleco/compass/components/Icon";
import type { Editor } from "@tiptap/react";

import { t } from "@/i18n-js/instance";

import { Portal } from "../../Shared/Portal";

export interface CaptionToolbarProps {
  editor: Editor | null;
  portalId: string;
}

export const CaptionToolbar = ({ editor, portalId }: CaptionToolbarProps) => {
  if (!editor) {
    return null;
  }

  return (
    <Portal selectorQuery={`#${portalId}`}>
      <div className="flex items-center md:pt-2">
        <EmojiPickerV4
          as="button"
          buttonAriaLabel={t("emoji_picker")}
          onEmojiSelect={emojiData => {
            if (!emojiData.emoji) return;
            editor.chain().focus().insertContent(emojiData.emoji).run();
          }}
          target={<Icon name="emoji-smiley" size="md" aria-hidden="true" />}
          targetWrapperClassName="size-9 items-center justify-center rounded-lg text-primary transition-colors hover:bg-secondary focus-visible:shadow-focus"
        />
      </div>
    </Portal>
  );
};
